<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
import camelCase from 'lodash/camelCase'

// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(
  require('@fortawesome/free-solid-svg-icons/faSortDown').definition,
  require('@fortawesome/pro-regular-svg-icons/faSync').definition,
  require('@fortawesome/pro-regular-svg-icons/faUser').definition,
  require('@fortawesome/pro-regular-svg-icons/faShareAlt').definition,
  require('@fortawesome/pro-regular-svg-icons/faInfo').definition,
  require('@fortawesome/pro-regular-svg-icons/faHomeAlt').definition,
  require('@fortawesome/pro-regular-svg-icons/faEllipsisH').definition,
  require('@fortawesome/pro-regular-svg-icons/faCaretDown').definition,
  require('@fortawesome/pro-regular-svg-icons/faExternalLinkAlt').definition,
  require('@fortawesome/pro-regular-svg-icons/faTicketAlt').definition,
  require('@fortawesome/pro-regular-svg-icons/faMinus').definition,
  require('@fortawesome/pro-regular-svg-icons/faPlus').definition,
  require('@fortawesome/pro-regular-svg-icons/faCheck').definition,
  require('@fortawesome/pro-regular-svg-icons/faEnvelope').definition,
  require('@fortawesome/pro-regular-svg-icons/faHome').definition,
  require('@fortawesome/pro-regular-svg-icons/faPhone').definition,
  require('@fortawesome/pro-regular-svg-icons/faCopy').definition,
  require('@fortawesome/pro-regular-svg-icons/faExclamation').definition,
  require('@fortawesome/free-brands-svg-icons/faLine').definition,
  require('@fortawesome/free-brands-svg-icons/faFacebook').definition,
  require('@fortawesome/pro-regular-svg-icons/faAngleDown').definition, // order-tickets.vue buefy numberInput
  require('@fortawesome/pro-regular-svg-icons/faAngleUp').definition, // order-tickets.vue buefy numberInput
  require('@fortawesome/pro-regular-svg-icons/faSearch').definition, // country calling code picker
  require('@fortawesome/pro-regular-svg-icons/faImage').definition, // booking no image icon
  require('@fortawesome/pro-regular-svg-icons/faExclamationCircle').definition, // booking-checkout.vue buefy field message
  require('@fortawesome/pro-regular-svg-icons/faPhoneVolume').definition, // booking.vue
  require('@fortawesome/pro-regular-svg-icons/faFilter').definition,
  require('@fortawesome/pro-regular-svg-icons/faSortAmountUp').definition,
  require('@fortawesome/pro-regular-svg-icons/faAngleRight').definition,
  require('@fortawesome/pro-regular-svg-icons/faAngleLeft').definition,
  require('@fortawesome/pro-regular-svg-icons/faPen').definition,
  // Subscription
  require("@fortawesome/pro-regular-svg-icons/faPencilAlt").definition,
  require("@fortawesome/free-brands-svg-icons/faCcAmex").definition,
  require("@fortawesome/free-brands-svg-icons/faCcDinersClub").definition,
  require("@fortawesome/free-brands-svg-icons/faCcJcb").definition,
  require("@fortawesome/free-brands-svg-icons/faCcMastercard").definition,
  require("@fortawesome/free-brands-svg-icons/faCcPaypal").definition,
  require("@fortawesome/free-brands-svg-icons/faCcVisa").definition,
  require('@fortawesome/pro-regular-svg-icons/faExclamationTriangle').definition,
);

export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: 'font-awesome',
    },
    name: {
      type: String,
      required: true,
    },
    className: {
      type: String,
    },
    iconStyle: {
      type: String,
      default: 'far',
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase('icon-custom-' + this.name)]
    },
  },
}
</script>

<template>
  <FontAwesomeIcon
    v-if="source === 'font-awesome'"
    :class="className"
    v-bind="$attrs"
    :icon="[iconStyle,name]"
  />
  <span v-else-if="source === 'custom'" v-bind="$attrs" :class="customIconClass" />
</template>
<style lang="scss">
.svg-inline--fa + span {
  margin-left: 0.25em;
}
</style>
